<template>
    <div class="faq-category-header">
        <div class="component-title">
            <h5 class="title">
                <i
                    class="fas fa-fw fa-user-lock teacher-icon"
                    v-b-tooltip.hover
                    v-if="categoryIn.teacher"
                    :title="$t('admin.visible_to_teacher')"></i>
                <i
                    class="fas fa-fw fa-user-graduate student-icon"
                    v-b-tooltip.hover
                    v-if="categoryIn.student"
                    :title="$t('admin.visible_to_student')"></i>
                {{ categoryIn.name }}
            </h5>
        </div>

        <div class="category-tools order-0 order-sm-1">
            <div class="context-nav context-nav-category">
                <b-dropdown
                    class="ellipsis-nav category-nav"
                    no-caret
                    variant="primary"
                    right
                    toggle-class="category-context-menu">
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                        class="edit-category"
                        @click.prevent.stop="changeCategory()">
                        <i class="btn-edit"></i>
                        {{ $t('admin.edit_category') }}
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="remove-category"
                        @click.prevent.stop="deleteCategory()">
                        <i class="btn-remove"></i>
                        {{ $t('admin.delete_category') }}
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="add-question"
                        @click.prevent.stop="addQuestion()">
                        <i class="btn-add"></i>
                        {{ $t('admin.add_question_and_answer') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-admin-afaq-category-header-component',
    props: ['categoryIn', 'afaqTagsIn'],

    methods: {
        changeCategory() {
            this.$emit('editCategory', this.categoryIn.id);
        },

        deleteCategory() {
            this.alert
                .confirm(this.$t('admin.faq_delete_category_title'), this.$t('admin.faq_delete_category_confirm'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();

                    this.axios
                        .delete(this.routes.adminAfaqCategory(), { data: { categoryId: this.categoryIn.id } })
                        .then(
                            (response) => {
                                this.categoryIn.remove();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                });
        },

        addQuestion() {
            this.$emit('show-create-faq-modal');
        },
    },
};
</script>

<style scoped lang="scss">
.faq-category-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .component-title,
    .title {
        margin-bottom: 0;
    }

    .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        line-height: 1;

        .teacher-icon,
        .student-icon {
            color: var(--primary);
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            align-self: center;
        }
    }
}
</style>
